module.exports = __webpack_public_path__ + "static/img/10.ef6372d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/zh/10.png
// module id = nUCz
// module chunks = 0